/**
 * @Author : zhouqinze
 * @Date : 2019-12-30
 * @Version : 1.0
 * @Content : 旗下项目
 **/
<template>
    <div class="comObj">
        <router-view></router-view>
    </div>
</template>

<script>
export default {
    
}
</script>

<style lang="scss" scoped>
    .comObj{
        width: 100%;
    }
</style>